import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import DesktopMacIcon from '@material-ui/icons/DesktopMac';
import TabletMacIcon from '@material-ui/icons/TabletMac';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import FullscreenIcon from '@material-ui/icons/Fullscreen';

import _e from 'common/localeUtil';
import GMButton from './button/GMButton';
import { handleClickPreviewButton } from '../utils';

const useStyles = makeStyles((theme) => ({
	leftPanelPreview: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
	},
	left: {
		flex: 1,
	},
	previewButtons: {
		textAlign: 'center',
		display: 'flex',
		flex: 0.5,
		flexDirection: 'row',
		justifyContent: 'space-between',
		paddingRight: theme.spacing(1),
	},
}));

const EditorLeftPanelPreview = ({ previewButtonTitle, handleOnPreview, hasDeviceTypeSelector }) => {
	const classes = useStyles();

	const handleDeviceTypeChanged = (device) => () => {
		window.gm_track(`Preview Device`, { device });
		window.grapesjs.setDevice(device);
	};

	return (
		<div id="left-panel-preview" className={`${classes.leftPanelPreview} full-screen-section`}>
			<div className={`${classes.left} flex-center`}>
				<div className={`${classes.left} flex marginRight10`}>
					<GMButton
						Icon={FullscreenIcon}
						titleAttr={previewButtonTitle}
						title={previewButtonTitle}
						onClick={handleOnPreview}
					/>
				</div>
			</div>

			{hasDeviceTypeSelector && (
				<div className={classes.previewButtons}>
					<GMButton
						Icon={DesktopMacIcon}
						titleAttr={_e('desktop')}
						onClick={handleDeviceTypeChanged('Desktop')}
					/>
					<GMButton
						Icon={TabletMacIcon}
						titleAttr={_e('tablet')}
						onClick={handleDeviceTypeChanged('Tablet')}
					/>
					<GMButton
						Icon={PhoneIphoneIcon}
						titleAttr={_e('mobile')}
						onClick={handleDeviceTypeChanged('Mobile portrait')}
					/>
				</div>
			)}
		</div>
	);
};

EditorLeftPanelPreview.defaultProps = {
	previewButtonTitle: _e('preview'),
	handleOnPreview: handleClickPreviewButton,
	hasDeviceTypeSelector: true,
};

EditorLeftPanelPreview.propTypes = {
	previewButtonTitle: PropTypes.string,
	handleOnPreview: PropTypes.func,
	hasDeviceTypeSelector: PropTypes.bool,
};

export default EditorLeftPanelPreview;
